import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment  from 'moment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-ledger',
  templateUrl: './ledger.component.html',
  styleUrls: ['./ledger.component.css']
})
export class LedgerComponent implements OnInit {
  constructor( private route: ActivatedRoute,private router: Router,private accService:AccountingService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
 
  PaymentModelSearch = {
    AccID: 0,
    FromDate:  moment(Date.now()).format("DD-MMM-YYYY"),
    ToDate:  moment(Date.now()).format("DD-MMM-YYYY"),
    Print:""
};

GetLedgerPrint  () {
  if (this.PaymentModelSearch.AccID > 0) {
    this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate != '' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
    this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null && this.PaymentModelSearch.ToDate!='' ? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
           

    var url = "ledgerprint?PrintType=LedgerPrint&FromDate=" +this.PaymentModelSearch.FromDate+ "&ToDate=" + this.PaymentModelSearch.ToDate + "&AccID=" + this.PaymentModelSearch.AccID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  }
};
SearchBankAccName = '';
ClearSearch  () {
    this.PaymentModelSearch.AccID = 0;
    this.PaymentModelSearch.FromDate = moment(Date.now()).format("DD-MMM-YYYY");
    this.PaymentModelSearch.ToDate = moment(Date.now()).format("DD-MMM-YYYY");
    this.SearchBankAccName = '';
    this.SearchSubmitted = false;
};
SearchSubmitted = false;
LedgerList:any;
AccDetails:any;
AccDetails1:any;
OpeningBalance= 0;
PreviousBalance=0;
validSearch(){
  return this.SearchBankAccName=='';
}

GetLedger  () {

    this.SearchSubmitted = true;
    if(!this.validSearch()){
    this.spinnerService.show();
    this.PaymentModelSearch.FromDate=this.PaymentModelSearch.FromDate!=null && this.PaymentModelSearch.FromDate!='' ?moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY'):'';
    this.PaymentModelSearch.ToDate= this.PaymentModelSearch.ToDate!=null && this.PaymentModelSearch.ToDate!=''?moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY'):'';
    this.accService.GetLedger(JSON.stringify(this.PaymentModelSearch)).subscribe( (response)=> {
      this.LedgerList = response.LedgerList;
      this.AccDetails = response.AccDetails;
      this.AccDetails1 = response.LedgerList[0];
      this.OpeningBalance = 0;
      for (var i = 0; i < this.LedgerList.length; i++) {

          this.PreviousBalance = this.LedgerList[i].VcAccountList[0].OpeningBalance;
         
          this.OpeningBalance = this.LedgerList[i].VcAccountList[0].OpeningBalance;
        
          for (var j = 0; j < this.LedgerList[i].VcAccountList.length; j++) {
           
              if (this.PreviousBalance >= 0) {
                  this.PreviousBalance = this.PreviousBalance - this.LedgerList[i].VcAccountList[j].DebitAmt +this.LedgerList[i].VcAccountList[j].CreditAmt;
              }
              else {
                  this.PreviousBalance = this.PreviousBalance -this.LedgerList[i].VcAccountList[j].DebitAmt +this.LedgerList[i].VcAccountList[j].CreditAmt;
              }
              //this.PreviousBalance = this.PreviousBalance + this.LedgerList[i].VcAccountList[j].DebitAmt - this.LedgerList[i].VcAccountList[j].CreditAmt;
              this.LedgerList[i].VcAccountList[j].OpeningBalance = this.PreviousBalance;


          }
          if (this.OpeningBalance>0) {
              this.LedgerList[i].TotalOpeningAmt = this.OpeningBalance + this.LedgerList[i].TotalDebitAmt - this.LedgerList[i].TotalCreditAmt;
          }
          else{
          this.LedgerList[i].TotalOpeningAmt = this.OpeningBalance - this.LedgerList[i].TotalDebitAmt + this.LedgerList[i].TotalCreditAmt;
      } //var itemBo = {
          //    Narration: "Opening Balance",
          //    DebitAmt: 0.000,
          //    CreditAmt: this.OpeningBalance,
          //}
          //this.LedgerList.push(itemBo);
      }

        setTimeout( ()=>{
          this.spinnerService.hide();
            this.SearchSubmitted = false;
            // this.globalHelper.CheckActionStatus(response);
        }, 10);
    });
  }
};
FilePath:any;
GetLedgerXLS  () {
    this.PaymentModelSearch.Print = 'XLS';   
   this.spinnerService.show()
   this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate != '' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
   this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null && this.PaymentModelSearch.ToDate!='' ? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
 
    this.accService.GetLedger(JSON.stringify(this.PaymentModelSearch)).subscribe( (response)=> {
        // this.AccountList = response.AccountList;
        this.FilePath = response.FilePath;
        window.location = response.FilePath;
        this.PaymentModelSearch.Print = "";
        setTimeout( () =>{
          
           
            this.spinnerService.hide()
           this.globalHelper. CheckActionStatus(response);

            this.PaymentModelSearch.Print = '';
        }, 10);
    });
};
onSelectCashSearch ($item) {

  this.PaymentModelSearch.AccID = $item.AccID;
}
AccountList:any;
GetAccount  () {
 
  this.lookupService.GetLookupsList('AllAcc',"").subscribe( (data) =>{
      this.AccountList = data.LookupItems;
      this.AccountList.splice(0, 1);
      setTimeout(() => {     
        this.PaymentModelSearch.FromDate = moment(this.globalHelper.GetLoginToken().SessionStartDate).format("DD-MMM-YYYY");
        this.PaymentModelSearch.ToDate = moment(this.globalHelper.GetLoginToken().SessionEndDate).format("DD-MMM-YYYY");
        this.route.queryParams.subscribe(params => {       
          this.AccDetails =  params['AccDetails'];         
        });

        if(this.AccDetails!=undefined){
          this.PaymentModelSearch.AccID=this.AccDetails;         
          this.SearchBankAccName=this.GetAccName(this.AccDetails);
          this.GetLedger();
         }
       
      }, 600);

  });
}
Print = 'P';
TransID = 0;
PrintVoucher(TransType,TransID,TransDate){
  this.Print = 'P';
  this.TransID =TransID; 
 
  if(TransType=='BPV' ||TransType=='CPV' ){
    var url = "voucherpaymentprint?ReportType=PrintBankReceipt&TransID=" + this.TransID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  }
 
  else if(TransType=='CRV' && TransType=='BRV'){
    var url = "voucherreceiptprint?ReportType=PrintCashReceipt&TransID=" + this.TransID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  }
 
  else if(TransType=='JV'){
    var url = "journalvoucherprint?ReportType=Printjournal&TransID=" + this.TransID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  }
  else if(TransType=='FC'){
    // this.router.navigate(['/feedailyclosing?'], {queryParams: {TransDate:TransDate}})
  }
  }
  
  GetAccName(id){
    for (let index = 0; index < this.AccountList.length; index++) {
     if(this.AccountList[index].AccID==id){
      return this.AccountList[index].AccName;

      break;
     }
      
      
    }
   
  }
  
  ngOnInit() {
    this.GetAccount();
    
   

    
    // this.GetLedger();
  }

}
